import {
    type UpdateBoardMemberResponseType,
    type UpdateBoardMemberRequestType
} from "./type";
import {
    request
} from "../request";

const updateBoardMember = async (params: UpdateBoardMemberRequestType): Promise<UpdateBoardMemberResponseType> => {
    return await request<UpdateBoardMemberResponseType>("/content/updateBoardMember", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default updateBoardMember;
